import { makeStyles } from "tss-react/mui";
import { constants } from "../../constants";

export const useStyles = makeStyles()((theme) => ({
    root: {
        position: "relative",
        width: "100%",
        height: "100vh",
        background: constants.color.black,
        overflow: "hidden",
        maxWidth: constants.dimensions.maxWidth,

        ".promptUI--closed &": {
            height: 124,
        },
        ".promptUI--open &": {
            height: "100vh",
            position: "fixed",
            top: 0,
        },
    },

    grid: {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(20, 1fr)",
        gridTemplateRows: "220px 1fr",
        columnGap: "24px",
        alignContent: "center",
        position: "relative",
    },

    logo: {
        margin: "44px 0 136px 0",
        height: "20px",
        textAlign: "center",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        transition: "0.33s ease-in-out",
        "& image": {
            color: constants.color.white,
            fill: constants.color.white,
        },
        ".promptUI--closed &": {
            opacity: 0,
            transitionDelay: "0",
            transform: "scale(0.66)",
        },
        ".promptUI--open &": {
            opacity: 1,
            transitionDelay: "0.2s",
            transform: "scale(1)",
        },
    },
    close: {
        position: "absolute",
        top: "44px",
        right: "24px",
        transition: "opacity 0.33s",

        "& button.MuiButtonBase-root.MuiButton-root": {
            display: "inline-block",
            padding: 0,
            width: "119px",
        },
        "& image": {
            color: constants.color.white,
            fill: constants.color.white,
        },
        ".promptUI--closed &": {
            opacity: 0,
        },
        ".promptUI--open &": {
            opacity: 1,
            zIndex: 51,
            transitionDelay: "0.5s",
        },
        ".promptUI--scrollable &": {
            display: "none",
        },
    },
    redwrap: {
        position: "absolute",
        width: "2px",
        height: "100%",
        backgroundColor: constants.color.red,
        transformOrigin: "bottom center",
        transition: "0.66s ease-out",
        left: 100,
        top: 220,

        ".promptUI--closed &": {
            transform: "scaleY(0)",
        },
        ".promptUI--scrollable &": {
            transition: "none",
        },
    },

    inputContainer: {
        gridColumn: "3 / 20",
        paddingTop: "24px",
        transformOrigin: "top left",
        position: "relative",
        transition: "transform 0.66s",
        top: 12,

        "& .caption": {
            color: constants.color.white,
            textTransform: "uppercase",
            letterSpacing: "2px",
            fontWeight: constants.fontWeight.plus,
            fontSize: "16px",
            marginBottom: "24px",
        },
        "& .input-box": {
            position: "relative",
            top: 0,
            transition: "top 0.33s",

            "& .MuiInputBase-root": {
                fontFamily: '"Galaxie Copernicus"',
                width: "100%",
                fontSize: "54px",
                fontWeight: 525,
                fontStyle: "italic",
                lineHeight: "70px",
                "& input": {
                    width: "100%",
                    color: constants.color.white,
                    transformOrigin: "left",
                    "&::placeholder": {
                        color: constants.color.white,
                        fontStyle: "italic",
                    },
                },
            },

            ".promptUI--closed &": {
                top: -20,
            },
        },
        ".promptUI--closed &": {
            transform: "scale(0.66)",
            hr: {
                display: "none",
            },
        },
    },
    summary: {
        marginTop: "26px",
        fontFamily: "Galaxie Copernicus",
        fontSize: "26px",
        fontStyle: "italic",
        fontWeight: 525,
        lineHeightStep: "34px",
        textAlign: "left",
        color: constants.color.white,
        "&.error": {
            "&::before": {
                content: "'!'",
                color: constants.color.alizarin,
            },
            "&::after": {
                content: "'!'",
                color: constants.color.alizarin,
            },
        },
    },
}));
